<div class="row">
	<div class="col-sm-12">
		<div class="content-header">Onboarding Form</div>
	</div>
  </div>
  <section id="ngx">
	<div class="card">
		<div class="card-content">
			<div class="card-body">
  
				<aw-wizard #wizard [navBarLayout]="'large-empty-symbols'">
					<aw-wizard-step [stepTitle]="'Step 1'" [navigationSymbol]="{ symbol: '&#xf007;', fontFamily: 'FontAwesome' }">
						
						<form [formGroup]="basicForm" (ngSubmit)="onBasicFormSubmit()">
							
							<div class="row">
							  <!-- <div class="col-md-6 col-12 form-group">
								<div class="media">
									<img *ngIf="!isEdit"  [src]="imgUrl?imgUrl:'assets/img/portrait/small/avatar-s-8.png'" (click)="fileInput.click()" alt="profile-img" class="rounded mr-3" height="64"
									  width="64">
									  <img *ngIf="isEdit && onboarding_model.photo"  [src]="imageBaseUrl+fileData" (click)="fileInput.click()" alt="profile-img" class="rounded mr-3" height="64"
									  width="64">  
									  <img *ngIf="isEdit && imgUrl" [src]="imgUrl" (click)="fileInput.click()" alt="profile-img" class="rounded mr-3" height="64"
									  width="64">
									<div class="media-body">
									  <div class="col-12 d-flex flex-sm-row flex-column justify-content-start px-0 mb-sm-2">
										<label class="btn btn-sm bg-light-primary mb-sm-0" for="select-files">{{isEdit?'Change':'Upload'}} Photo</label>
										<input type="file" id="select-files" #fileInput  (change)="onSelectFile($event)"  hidden>
										<button class="btn btn-sm bg-light-secondary ml-sm-2" (click)="resetFile()">Reset</button>
									  </div>
									  <p class="text-muted mb-0 mt-1 mt-sm-0">
										<small>Allowed JPG, GIF or PNG. Max size of 800kB</small>
									  </p>
									</div>
								  </div>
							  </div> -->
							  <div class="col-12 col-md-6 form-group">
								<label for="title">About<span class="required_field">*</span></label>
								<div class="controls">
									<textarea name="about"  formControlName="about" [(ngModel)]="onboarding_model.about" class="form-control" id="about" cols="30" rows="3" placeholder="about" [ngClass]="{ 'is-invalid': basicFormSubmitted && bf.about.invalid, 'is-valid': basicFormSubmitted && !bf.about.invalid }"></textarea>
									<div *ngIf="basicFormSubmitted && (bf.about.invalid || bf.about.errors?.required)"
									class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> This is
									required</div>
								</div>
							  </div>
							  
							  <div class="col-12 d-flex flex-sm-row flex-column justify-content-end">
								<button [disabled]="!basicForm.valid" type="submit" class="btn btn-primary mr-sm-2 my-2" awNextStep >Next</button>
							  </div>
							</div>
						  </form>
					</aw-wizard-step>
					<aw-wizard-step  [stepTitle]="'Step 2'" [navigationSymbol]="{ symbol: '&#xf0b1;', fontFamily: 'FontAwesome' }">
						<form [formGroup]="basicForm2" (ngSubmit)="onBasicFormSubmit2()">
							<div class="row">
								<div class="col-12 col-md-6 form-group">
									<label for="title">Resume<span class="required_field">*</span></label>
									<div class="controls">
									  <input type="text" formControlName="resume" [(ngModel)]="onboarding_model.resume" class="form-control" placeholder="resume"
										[ngClass]="{ 'is-invalid': basicFormSubmitted2 && bf2.resume.invalid, 'is-valid': basicFormSubmitted2 && !bf2.resume.invalid }"
										required>
									  <div *ngIf="basicFormSubmitted2 && (bf2.resume.invalid || bf2.resume.errors?.required)"
										class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> This is
										required</div>
									</div>
								  </div>
								  <div class="col-12 col-md-6 form-group">
									<label for="title">LinkedIn<span class="required_field">*</span></label>
									<div class="controls">
									  <input type="text" formControlName="linkedIn" [(ngModel)]="onboarding_model.linkedIn" class="form-control" placeholder="linkedIn"
										[ngClass]="{ 'is-invalid': basicFormSubmitted2 && bf2.linkedIn.invalid, 'is-valid': basicFormSubmitted2 && !bf2.linkedIn.invalid }"
										required>
									  <div *ngIf="basicFormSubmitted2 && (bf2.linkedIn.invalid || bf2.linkedIn.errors?.required)"
										class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> This is
										required</div>
									</div>
								  </div>
								  <div class="row">
									  <div class="col-12 form-group my-2">
										<label>Student Empowerment</label>
										<div class="controls">
											<mat-slide-toggle color="primary" [checked]="onboarding_model.is_interested"
											  (change)="onboarding_model.is_interested = !onboarding_model.is_interested">Are you interested ?</mat-slide-toggle>
										</div>
									  </div>
								  </div>
							  <div class="col-12 d-flex flex-sm-row flex-column justify-content-end">
								<button type="submit" class="btn btn-secondary mr-sm-2 my-2" awPreviousStep >Previous</button>
								<button [disabled]="!basicForm2.valid" type="submit" class="btn btn-primary mr-sm-2 my-2" awNextStep >Next</button>
							  </div>
							</div>
						  </form>
					</aw-wizard-step>
					<aw-wizard-step [stepTitle]="'Step 3'" [navigationSymbol]="{ symbol: '&#xf0ac;', fontFamily: 'FontAwesome' }">
						<form [formGroup]="basicForm3" (ngSubmit)="onBasicFormSubmit3()">
							<div class="row">
								<div class="col-12 col-md-6 form-group">
									<label for="title">Notes</label>
									<div class="controls">
										<textarea name="notes"  formControlName="notes" [(ngModel)]="onboarding_model.notes" class="form-control" id="notes" cols="30" rows="3" placeholder="notes"></textarea>
									</div>
								  </div>
								  <div class="col-12 col-md-6 form-group">
									<label for="title">Admin Notes</label>
									<div class="controls">
										<textarea name="admin_notes"  formControlName="admin_notes" [(ngModel)]="onboarding_model.admin_notes" class="form-control" id="notes" cols="30" rows="3" placeholder="admin_notes"></textarea>
									</div>
								  </div>
							  <div class="col-12 d-flex flex-sm-row flex-column justify-content-end">
								<button type="submit" class="btn btn-secondary mr-sm-2 my-2" awPreviousStep>Previous</button>
								<button [disabled]="isEdit &&onboarding_model.status ==='approved'" type="submit" class="btn btn-primary mr-sm-2 my-2" (click)="submit()" awResetWizard>Finish</button>
							  </div>
							</div>
						  </form>
  
					</aw-wizard-step>
				</aw-wizard>
  
  
			</div>
		</div>
	</div>
  </section>
  